module.exports = __webpack_public_path__ + "img/123.found.41a2a121.svg";